var _g, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon8(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 181 59",
    enableBackground: "new 0 0 181 59",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M48.5,11.2H55v1.2h-5v3.1h3.8v1.2h-3.8v3.1h5V21h-6.5V11.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.4,14.3h1.4v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3v1.1c-0.7,0-1.3,0.1-1.8,0.3 c-0.5,0.2-0.9,0.6-1.1,1.1V21h-1.4V14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.4,20.3c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4 c0.5,0.3,0.9,0.7,1.2,1.2c0.3,0.5,0.4,1.1,0.4,1.8v0.7h-5.9c0,0.6,0.3,1.1,0.8,1.4c0.5,0.3,1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1 c0.4-0.1,0.8-0.2,1.2-0.3v1.1c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C64.1,21.2,63.1,20.9,62.4,20.3z M67.2,17.2 c0-0.6-0.2-1.1-0.6-1.5c-0.4-0.4-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H67.2z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.7,20.8c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.4,0.5-1.9c0.3-0.5,0.8-0.9,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 c0,0.8,0.2,1.4,0.7,1.8s1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5c-0.4,0.1-0.9,0.2-1.5,0.2 C72.9,21.2,72.2,21,71.7,20.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M78.8,20.6c-0.4-0.4-0.6-0.9-0.6-1.7v-3.6h-1v-1.1h1v-2h1.4v2h1.7v1.1h-1.7v3.5c0,0.4,0.1,0.8,0.3,1 c0.2,0.2,0.5,0.3,0.9,0.3c0.3,0,0.5-0.1,0.8-0.2V21c-0.4,0.1-0.8,0.2-1.3,0.2C79.7,21.2,79.2,21,78.8,20.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.2,12.7c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C83.6,12.9,83.4,12.9,83.2,12.7z M83.1,14.3h1.4V21h-1.4V14.3 z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.1,20.8c-0.6-0.3-1-0.7-1.3-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.3,0.5-1.9c0.3-0.5,0.8-1,1.3-1.3 c0.6-0.3,1.2-0.4,2-0.4s1.4,0.1,2,0.4c0.6,0.3,1,0.7,1.4,1.3c0.3,0.5,0.5,1.2,0.5,1.9c0,0.7-0.2,1.4-0.5,1.9 c-0.3,0.5-0.8,0.9-1.4,1.2c-0.6,0.3-1.2,0.4-2,0.4S88.6,21,88.1,20.8z M91.8,19.4c0.4-0.4,0.6-1,0.6-1.8c0-0.8-0.2-1.4-0.6-1.8 c-0.4-0.4-1-0.7-1.7-0.7c-0.7,0-1.3,0.2-1.7,0.7c-0.4,0.4-0.6,1-0.6,1.8c0,0.7,0.2,1.3,0.6,1.8c0.4,0.4,1,0.7,1.7,0.7 C90.8,20.1,91.4,19.8,91.8,19.4z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.4,14.3h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9V21h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3s-0.7,0.5-1,1V21h-1.4V14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.6,11.2h1.4l3.9,9.8h-1.5l-1-2.4h-4.3l-1,2.4h-1.5L112.6,11.2z M115.1,17.3l-1.8-4.6l-1.8,4.6H115.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.4,10.6h1.4V21h-1.4V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.7,10.6h1.4V21h-1.4V10.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M131.1,11.2h3.9c1,0,1.8,0.3,2.4,0.8c0.6,0.5,0.8,1.2,0.8,2.2c0,0.7-0.2,1.3-0.6,1.8c-0.4,0.5-0.9,0.8-1.6,1l2.2,4h-1.5 l-2.1-3.9h-2.1V21h-1.4V11.2z M134.8,15.9c0.6,0,1.1-0.1,1.5-0.4c0.4-0.3,0.6-0.7,0.6-1.3c0-0.6-0.2-1.1-0.5-1.4 c-0.4-0.3-0.9-0.4-1.5-0.4h-2.3v3.5H134.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M140.1,12.7c-0.2-0.2-0.2-0.4-0.2-0.6s0.1-0.4,0.2-0.6c0.2-0.2,0.4-0.2,0.6-0.2c0.2,0,0.4,0.1,0.6,0.2 c0.2,0.2,0.2,0.4,0.2,0.6s-0.1,0.4-0.2,0.6c-0.2,0.2-0.4,0.2-0.6,0.2C140.4,12.9,140.2,12.9,140.1,12.7z M139.9,14.3h1.4V21h-1.4 V14.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M144.3,21c-0.5-0.1-0.9-0.3-1.2-0.5v-1.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 c0.2-0.1,0.4-0.3,0.4-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5 c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.2,1,0.4v1.2c-0.3-0.2-0.6-0.3-1-0.4s-0.8-0.1-1.2-0.1c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8c0.3,0.3,0.5,0.8,0.5,1.3 c0,0.6-0.2,1-0.7,1.4c-0.5,0.3-1.2,0.5-2.1,0.5C145.3,21.2,144.8,21.1,144.3,21z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M150.2,10.6h1.4V21h-1.4V10.6z M151.6,17.6l3.1-3.3h1.7l-3.1,3.3l3.4,3.4H155L151.6,17.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.5,28H50v9.8h-1.4V28z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51.8,31.1h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3H57 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M61.2,37.8c-0.5-0.1-0.9-0.3-1.2-0.5v-1.2c0.4,0.2,0.8,0.4,1.3,0.5c0.5,0.1,0.9,0.2,1.4,0.2c0.5,0,0.9-0.1,1.1-0.2 c0.2-0.1,0.4-0.3,0.4-0.6c0-0.2-0.1-0.4-0.2-0.5c-0.1-0.1-0.3-0.2-0.5-0.3c-0.3-0.1-0.6-0.2-1.2-0.4c-0.6-0.2-1-0.3-1.3-0.5 c-0.3-0.2-0.6-0.4-0.7-0.6c-0.2-0.3-0.2-0.6-0.2-1c0-0.6,0.3-1.1,0.8-1.5c0.5-0.3,1.2-0.5,2.1-0.5c0.4,0,0.9,0,1.3,0.1 c0.4,0.1,0.8,0.2,1,0.4v1.2c-0.3-0.2-0.6-0.3-1-0.4C63.7,32,63.3,32,62.8,32c-0.5,0-0.9,0.1-1.1,0.2c-0.3,0.1-0.4,0.3-0.4,0.6 c0,0.2,0.1,0.4,0.2,0.5c0.1,0.1,0.3,0.2,0.5,0.3c0.2,0.1,0.6,0.2,1.2,0.3c0.8,0.2,1.4,0.5,1.8,0.8c0.3,0.3,0.5,0.8,0.5,1.3 c0,0.6-0.2,1-0.7,1.4c-0.5,0.3-1.2,0.5-2.1,0.5C62.2,38,61.7,37.9,61.2,37.8z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.6,37.3c-0.5-0.5-0.7-1.1-0.7-1.9v-4.3h1.4v4.2c0,1.1,0.5,1.6,1.6,1.6c0.9,0,1.7-0.4,2.2-1.3v-4.5h1.4v6.7h-1.4v-1 c-0.3,0.4-0.7,0.7-1.1,0.9c-0.4,0.2-0.9,0.3-1.4,0.3C68.8,38,68.1,37.7,67.6,37.3z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.4,31.1h1.4v1.2c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,1.1-0.3,1.8-0.3v1.1c-0.7,0-1.3,0.1-1.8,0.3 c-0.5,0.2-0.9,0.6-1.1,1.1v4.2h-1.4V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M80.8,37.4c-0.5-0.4-0.7-1-0.7-1.7c0-0.7,0.2-1.3,0.7-1.7c0.5-0.4,1.1-0.6,2-0.6c0.9,0,1.7,0.2,2.4,0.6v-0.4 c0-0.5-0.2-0.9-0.5-1.2S83.9,32,83.2,32c-0.4,0-0.8,0-1.2,0.1c-0.4,0.1-0.7,0.2-1,0.3v-1.1c0.3-0.1,0.6-0.2,1.1-0.3 c0.4-0.1,0.9-0.1,1.3-0.1c1.1,0,1.9,0.2,2.5,0.7c0.5,0.5,0.8,1.2,0.8,2v4.2h-1.3V37c-0.3,0.3-0.6,0.6-1,0.7S83.4,38,82.8,38 C82,38,81.3,37.8,80.8,37.4z M84.3,36.6c0.4-0.2,0.6-0.4,0.8-0.7V35c-0.6-0.4-1.3-0.6-2-0.6c-0.5,0-0.9,0.1-1.2,0.3 c-0.3,0.2-0.4,0.5-0.4,1c0,0.8,0.5,1.2,1.6,1.2C83.6,36.9,84,36.8,84.3,36.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M88.3,31.1h1.4v1c0.3-0.4,0.7-0.7,1.2-0.9c0.5-0.2,0.9-0.3,1.4-0.3c0.9,0,1.6,0.2,2,0.7c0.4,0.5,0.7,1.1,0.7,1.9v4.3h-1.4 v-4.2c0-1.1-0.5-1.6-1.6-1.6c-0.4,0-0.9,0.1-1.3,0.3c-0.4,0.2-0.7,0.5-1,1v4.5h-1.4V31.1z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M98.3,37.6c-0.6-0.3-1-0.7-1.4-1.2c-0.3-0.5-0.5-1.2-0.5-1.9c0-0.7,0.2-1.4,0.5-1.9c0.3-0.5,0.8-1,1.4-1.2 c0.6-0.3,1.3-0.4,2-0.4c1,0,1.8,0.2,2.5,0.6v1.2c-0.6-0.4-1.4-0.6-2.3-0.6c-0.8,0-1.4,0.2-1.9,0.6c-0.5,0.4-0.7,1-0.7,1.8 c0,0.8,0.2,1.4,0.7,1.8c0.5,0.4,1.1,0.6,1.8,0.6c0.9,0,1.8-0.2,2.4-0.7v1.1c-0.3,0.2-0.7,0.4-1.1,0.5s-0.9,0.2-1.5,0.2 C99.5,38,98.9,37.8,98.3,37.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.2,37c-0.7-0.6-1.1-1.5-1.1-2.6c0-1.1,0.3-2,0.9-2.6c0.6-0.6,1.5-1,2.7-1c0.8,0,1.4,0.1,2,0.4s0.9,0.7,1.2,1.2 c0.3,0.5,0.4,1.1,0.4,1.8V35h-5.9c0,0.6,0.3,1.1,0.8,1.4s1.2,0.5,2,0.5c0.4,0,0.9,0,1.3-0.1s0.8-0.2,1.2-0.3v1.1 c-0.3,0.1-0.7,0.2-1.2,0.3c-0.5,0.1-1,0.1-1.4,0.1C106.9,38,105.9,37.7,105.2,37z M110,34c0-0.6-0.2-1.1-0.6-1.5 c-0.4-0.3-1-0.5-1.7-0.5c-0.7,0-1.3,0.2-1.7,0.5c-0.4,0.4-0.6,0.8-0.6,1.5H110z"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M16.9,21.9 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8C3.2,30.6,8.4,34,9.9,34.9 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C17.6,22.3,17.3,22,16.9,21.9z"
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 7.3,
    y1: 26.8,
    x2: 13.2,
    y2: 26.8
  }), /*#__PURE__*/React.createElement("line", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    x1: 10.2,
    y1: 23.8,
    x2: 10.2,
    y2: 29.7
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M38.3,7.3 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.9,5.5,11.3,6.9,12.1 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C39,7.7,38.7,7.3,38.3,7.3z"
  }), /*#__PURE__*/React.createElement("polyline", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    points: "29,12.2  31.3,14.4 35.3,10.3  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    d: "M40.3,28.9 c-2.6-0.3-5.1-2.3-6.1-3.2c-0.3-0.3-0.7-0.3-1,0c-1,0.9-3.5,2.8-6.1,3.2c-0.4,0.1-0.7,0.4-0.7,0.8c0.3,7.9,5.5,11.3,6.9,12.1 c0.2,0.1,0.5,0.1,0.8,0c1.5-0.8,6.6-4.3,6.9-12.1C41.1,29.3,40.8,29,40.3,28.9z"
  }), /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 0.9 30.6696 37.6099)",
    fontFamily: "'Prompt-Light'",
    fontSize: "10.9718px"
  }, "$")), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M13.8,17.5 c1.9-3.2,5.1-5.7,8.8-6.6"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M24.4,38.5 c-3.6-0.4-6.8-2.2-9.1-4.8"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "#000000",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeDasharray: "1,4",
    d: "M38.6,18.6 c0.9,1.8,1.4,3.9,1.4,6c0,1-0.1,2-0.3,2.9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon8);
export default __webpack_public_path__ + "static/media/icon-8.f215b4ada0e3effb0adc8cee2ed664d2.svg";
export { ForwardRef as ReactComponent };